/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-irregular-whitespace */
import React from 'react';
import logoStone from '../../assets/icons/logo-stone.svg';
import { ContentContract } from './styles';
import Footer from '../Footer';
import Header from '../Header';
import HeaderFull from '../HeaderFull';
import PDF from './components/PDF';

const Contract: React.FC = () => {
  return (
    <>
      <HeaderFull />
      <Header />
      <ContentContract>
        <img src={logoStone} alt="Stone Logo" />
        <label>Gestão de Pagamentos Stone</label>
        <PDF pdf={localStorage.getItem('pdf')} />
      </ContentContract>
      <Footer />
    </>
  );
};
export default Contract;
